import React, { useEffect, useState } from 'react';
import { Button } from '@storebrand-digital/pretzel';
import { getText } from '@storebrand-digital/fms-translations';
import { useAppSelector } from '../../app/store';
import { selectFilters } from './selectors';
import { Badge } from '@storebrand-digital/pretzel';
import { useDocumentContext } from '../Document/context';
import Filter from './Filter';
import styles from './Filter.Root.module.css';
import { Segment } from '../../utils/segments';
import FilterChips from './Filter.Chips';

function FilterRoot() {
  const filters = useAppSelector(selectFilters);
  const { selectedSegmentId } = useDocumentContext();
  const isBankSegment = selectedSegmentId === Segment.BANK;

  const [segmentOpenState, setSegmentOpenState] = useState<
    Record<string, boolean>
  >({});
  const open = segmentOpenState[selectedSegmentId] ?? false;

  function hasFilterValue(value: unknown): boolean {
    if (Array.isArray(value)) {
      return value.length > 0;
    }
    return !!value;
  }

  function calculateActiveFilters() {
    let countableKeys;

    if (isBankSegment) {
      countableKeys = ['createdFrom', 'createdTo'] as const;
    } else {
      countableKeys = [
        'createdFrom',
        'createdTo',
        'contractNumbers',
        'products',
        'categories',
      ] as const;
    }

    return countableKeys.reduce((count, key) => {
      const filterValue = filters[key];
      return count + (hasFilterValue(filterValue) ? 1 : 0);
    }, 0);
  }

  const activeFilterCount = calculateActiveFilters();
  const filterButtonText = getText(!open ? 'filter' : 'closeFilter');

  // track the open state of the filter base per segment
  useEffect(
    function initializeFilterBaseState() {
      if (segmentOpenState[selectedSegmentId] === undefined) {
        setSegmentOpenState((prev) => ({
          ...prev,
          [selectedSegmentId]: isBankSegment,
        }));
      }
    },
    [selectedSegmentId, isBankSegment, segmentOpenState]
  );

  function toggleOpen() {
    setSegmentOpenState((prev) => ({
      ...prev,
      [selectedSegmentId]: !open,
    }));
  }

  function onFilterClick(e: React.MouseEvent) {
    e.preventDefault();
    toggleOpen();
  }
  const showChips = selectedSegmentId === Segment.MAIN && activeFilterCount > 0;
  const filterRootContainerClasses = [
    open && 'filter-base-expanded',
    showChips && 'filter-base-with-chips',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div
      className={[styles.filterRootBase, filterRootContainerClasses]
        .filter(Boolean)
        .join(' ')}
    >
      <div className={styles.filterRootWrapper}>
        {showChips ? <FilterChips /> : <div />}
        <Button
          variant="subtle"
          className="button-archive_filter"
          data-trackid={
            !open
              ? isBankSegment
                ? 'button-filter_bank|Filter (Bankfilter)'
                : 'button-filter_main|Filter (Hovedfilter)'
              : undefined
          }
          iconRight="sliders-horizontal"
          onClick={onFilterClick}
        >
          {!open && activeFilterCount > 0 && (
            <Badge
              variant="neutral"
              density="compact"
              heading={activeFilterCount}
            />
          )}
          {filterButtonText}
        </Button>
      </div>
      <Filter.Overview />
    </div>
  );
}

export default FilterRoot;
